// extracted by mini-css-extract-plugin
export var indeterminate = "_48-5";
export var md = "_48-4";
export var semantic = "_48-6";
export var sm = "_48-3";
export var text = "_48-7";
export var toggleInput = "_48-0";
export var toggleSwitch = "_48-1";
export var xs = "_48-2";